//root modules and component//
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule, ErrorHandler } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { GlobalErrorComponent } from './global-error.component'
import { SignupComponent } from './mentor/components/signup/signup.component'
import { VerifyEmailComponent } from './mentor/components/verify-email/verify-email.component'
import { SignupscholarComponent } from './scholar/components/signupscholar/signupscholar.component'
//services//
import { MentorService } from './mentor/services/mentors.service'
import { AdminAuthService } from './admin/services/admin-auth.service'
import { ScholarAuthService } from './scholar/services/scholar-auth.service'
import { AmazingTimePickerService } from 'amazing-time-picker';
import { ErrorInterceptor } from './shared/services/error-interceptor'
// import {AdminModule}from'./admin/admin.module'
import { SharedModule } from './shared/shared.module'
// import {ScholarModule}from'./scholar/scholar.module'
// import {MentorModule} from './mentor/mentor.module'
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { GlobalErrorHandlerService } from './global-error-handler.service';
import { VERSION } from '@angular/common';
import { AdminAuthInterceptor } from './admin/services/admin-interceptor.service';
import { MentorAuthInterceptor } from './mentor/services/mentor-interceptor.service';
import { ScholarAuthInterceptor } from './scholar/services/scholar-interceptor.service';
import { SharedService } from './shared/services/shared.service';
import { MinTimeValidator } from './shared/directives/time-validator-directive';
// import { FooterComponent } from './shared/components/footer/footer.component';
// user defined modules//
@NgModule({
  declarations: [
    AppComponent, GlobalErrorComponent, SignupComponent, VerifyEmailComponent, SignupscholarComponent,
    MinTimeValidator,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
  ],
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService }
    , MentorService, AdminAuthService, AmazingTimePickerService, ScholarAuthService,
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]

})
export class AppModule { }
